import { render } from "./HeroiconsSolidMenuAlt1.vue?vue&type=template&id=7e189390"
const script = {}

import exportComponent from "/Users/yllndritb/Projects/rent/rent-api/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidMenuAlt1.vue"]])

export default __exports__